/**
 * @class msysMessage_equal
 * @description
 * Provides function to compare two messages, useful for tests
 */

const base = require('./base.js')
module.exports = { equal }

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Compares two mosy messages
 * @param {object} msg1
 * @param {object} msg2
 */
function equal(msg1, msg2, ignore_event_dt) {
  msg1 = base.string2msg(msg1)
  msg2 = base.string2msg(msg2)
  if(!msg1 && !msg2) return true
  if(!msg1 || !msg2) return false

  if(base.address2string(msg1.sender) !== base.address2string(msg2.sender)) return false
  if(base.address2string(msg1.target) !== base.address2string(msg2.target)) return false
  if(msg1.action !== msg2.action) return false

  const params1 = { ...msg1.params }
  const params2 = { ...msg2.params }
  if(ignore_event_dt) {
    delete params1.event_dt
    delete params2.event_dt
  }

  return _.isEqual(params1, params2)
} // equal
